import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import invariant from 'react-utils/invariant';
import { DEFAULT_BULK_ACTIONS_SURVEYMONKEY_SEND_MODAL_KEY } from '../../constants/modalKeys';
import { useBulkActionsHasError } from '../../hooks/useBulkActionsHasError';
import { useBulkActionsIsLoading } from '../../hooks/useBulkActionsIsLoading';
import { useBulkActionsOpenModal } from '../../hooks/useBulkActionsOpenModal';
import { useBulkActionsSelectionState } from '../../hooks/useBulkActionsSelectionState';
import useSurveyMonkeySettings from '../../hooks/useSurveyMonkeySettings';
import { BaseBulkActionButton } from './BaseBulkActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const SurveyMonkeyEnabledObjectTypes = [CONTACT];
export const SurveyMonkeySend = () => {
  const openModal = useBulkActionsOpenModal();
  const {
    selectionObjectTypeId
  } = useBulkActionsSelectionState();
  const objectType = ObjectTypeFromIds[selectionObjectTypeId];
  const isSurveyMonkeyObjectType = SurveyMonkeyEnabledObjectTypes.includes(objectType);
  invariant(isSurveyMonkeyObjectType, 'expected objectType to be [%s] but got "%s"', SurveyMonkeyEnabledObjectTypes, objectType);
  const isBulkActionLoading = useBulkActionsIsLoading();
  const hasError = useBulkActionsHasError();
  const surveyMonkeySettings = useSurveyMonkeySettings();
  const isLoading = isBulkActionLoading || surveyMonkeySettings === null;
  const disabled = isBulkActionLoading || hasError;
  const onClick = useCallback(() => {
    openModal({
      modalKey: DEFAULT_BULK_ACTIONS_SURVEYMONKEY_SEND_MODAL_KEY,
      props: {}
    });
  }, [openModal]);
  if (!surveyMonkeySettings || !surveyMonkeySettings.enabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(BaseBulkActionButton, {
    onClick: onClick,
    disabled: disabled,
    isLoading: isLoading,
    disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonDisabledTooltips.surveyMonkeySend"
    }),
    "data-selenium-test": "bulk-action-surveymonkey-send",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonLabels.surveyMonkeySend"
    })
  });
};